import React, { Component } from 'react';
import {MDBRow,MDBCol} from "mdbreact";
import {
    FCheckbox,
    FRadio,
    FSelect,
    FText,
    FDate,
    FFile,
    FTime,
    Ftextarea,
    FHeader
 } from "../form/index";
class FieldsLeft extends Component {
  constructor(props){
    super(props)
    this.state = {
      selected: true,
      class: 'padding ',
      rule: this.props.rule,
      Resumen:  [] 
    }
  }

  
  render() {
    const FromField = this.props.field
    //console.log('this.props.field :', this.props.field);
    return (
        
        <MDBRow >
        {FromField.map((field, i)=>(

                field.type === 'radio-group' ? (
                    <MDBCol size="6"  className="cursor">
                        <FRadio key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput}  field={field}/>
                    </MDBCol>
                )
                :
                (field.type === 'select' && !field.data_portal) ? (
                    <MDBCol size="6" className="cursor" >
                        <FSelect key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                )
                :
                field.type === 'text' ? (
                    <MDBCol size="6" className="cursor" >
                        <FText key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                ):
                field.type === 'header' ? (
                
                    <MDBCol size="12" className="cursor">
                    <hr/>
                    <FHeader  key={i} id={i + field.label}  field={field}/>
                    </MDBCol>
                )
                :
                field.type === 'date' ? (
                    <MDBCol size="6" className="cursor" >
                        <FDate key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                )

                :
                field.type === 'time' ? (
                    <MDBCol size="6" className="cursor" >
                        <FTime key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                )


                :
                field.type === 'file' ? (
                    <MDBCol size="6" className="cursor" >
                        <FFile key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                )

                :
                field.type === 'textarea' ? (
                    <MDBCol size="6" className="cursor" >
                        <Ftextarea key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                )

                :
                field.type === 'checkbox-group' && (
                    <MDBCol size="6" className="cursor" >
                        <FCheckbox key={i} id={i + field.label} handlerFromInput={this.props.FromInput} fieldFromInput={this.props.FieldFromInput} field={field}/>
                    </MDBCol>
                )
                    
            
        ))}
    </MDBRow>
    );
  }

 


 
}

export default FieldsLeft;